import React from 'react';
import { Row } from 'react-bootstrap';
import OrderInspections from '../../OrderInspections';
import OrderDownloads from '../../OrderDownloads';
import OrderUploadRequests from '../../OrderUploadRequests';
import type { Order } from '../../../../api/schemas/OrderSchema';
import type { SolarFarm } from '../../../../api/schemas/SolarFarmSchema';

interface OrderDataTabProps {
  order: Order;
  solarFarm: SolarFarm;
}

const OrderDataTab = ({ order, solarFarm }: OrderDataTabProps) => {
  return (
    <>
      <Row>
        {/* @ts-expect-error js/ts issues? */}
        <OrderInspections solarFarm={solarFarm} order={order} />
      </Row>
      <div className="order-edit-divider" />
      <Row>
        <OrderDownloads order={order} />
      </Row>
      <Row>
        <OrderUploadRequests order={order} />
      </Row>
    </>
  );
};

export default OrderDataTab;
